import { useEffect } from 'react'
import { usePlausible } from 'next-plausible'
import { createBookingTracker } from '@/lib/calendly-booking-tracking.mjs'

export default function CalendlyBookingTracking() {
  const plausible = usePlausible()

  useEffect(() => {
    let storage
    try { storage = window.sessionStorage } catch { /* Storage access is optional. */ }
    const recordBooking = createBookingTracker({
      frames: () => Array.from(document.querySelectorAll('iframe')),
      storage,
      lookup: async eventUuid => {
        const response = await fetch('/api/calendly/meeting-type', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ eventUuid }),
        })
        if (!response.ok) throw new Error('Calendly booking tracking could not identify the meeting.')
        return (await response.json()).meeting_type
      },
      track: plausible,
      onError: error => console.error(error.message),
    })
    window.addEventListener('message', recordBooking)
    return () => window.removeEventListener('message', recordBooking)
  }, [plausible])

  return null
}
